import { UiModal, ModalType, UiButton } from "@ui-monorepo/index";
import { useMemo } from "react";
import { MainSidebarMenuEvents } from "../../main-header-sidebar-menu.events";
import { useMainHeaderSidebarMenu } from "../../main-header-sidebar-menu.hook";
import { MainHeaderSideMenuProps } from "../../main-header-sidebar-menu.types";
import styles from "./sidebar-menu-2.module.css";
import {
  AppLink,
  useAppLocation,
  categoryNormalize,
  makeUrl } from
"@commons-monorepo/index";

export const MainHeaderSideMenu2 = ({
  onClose,
  hasWholesale,
  hasServices,
  hasOffers,
  categories,
  theme: themeContext,
  storeMetadata,
  data
}: MainHeaderSideMenuProps) => {
  const {
    t,
    logEvent,
    isLoggedIn,
    handleShowLogin,
    handleCloseSession,
    handleShowStoreInfo,
    categoriesShowList,
    handleClickCategoriesList,
    categorySelected,
    handleSelectCategory,
    handleShowSubcategories,
    storeUserPathName,
    data: user,
    SHOW_LOGIN_BUTTON
  } = useMainHeaderSidebarMenu({
    data,
    templateId: themeContext?.templateId,
    storeMetadata
  });
  const { pathname } = useAppLocation();
  const dataAboutUs = storeMetadata?.catalogueAboutUs;
  const ItemLink = ({
    to,
    children,
    onClick




  }: {to: string;children: JSX.Element | string;onClick?: () => void;}) =>
  <AppLink
    to={to}
    className={styles.sideMenu2Link}
    onClick={() => {
      onClick && onClick();
      onClose();
    }}>

      {children}
    </AppLink>;


  const menuItems = useMemo(() => {
    return [
    {
      link: `${pathname}/${makeUrl(pathname, `todos-los-productos`)}`,
      icon: "icon-bag",
      text: t("main_header.all_products"),
      onClick: () => {
        logEvent(MainSidebarMenuEvents.SelectMenuAllProducts, {
          Template_id: themeContext.templateId,
          platform: "web",
          user_type: "buyer",
          option: "all_products",
          method: "desktop"
        });
      }
    },
    ...(hasOffers ?
    [
    {
      link: `${pathname}/${makeUrl(pathname, "ofertas")}`,
      icon: "icon-light-percent",
      text: t("main_header.seller"),
      onClick: () => {
        logEvent(MainSidebarMenuEvents.SelectMenuOffers, {
          Template_id: themeContext.templateId
        });
      }
    }] :

    []),
    ...(hasWholesale ?
    [
    {
      link: `${pathname}/${makeUrl(pathname, "ventas-mayoreo")}`,
      icon: "icon-light-package",
      text: t("main_header.wholesale"),
      onClick: () => {
        logEvent(MainSidebarMenuEvents.SelectMenuWholesale, {
          Template_id: themeContext.templateId
        });
      }
    }] :

    []),
    ...(hasServices ?
    [
    {
      link: `${pathname}/${makeUrl(pathname, "servicios")}`,
      icon: "icon-handshake-outline",
      text: t("main_header.services"),
      onClick: () => {
        logEvent(MainSidebarMenuEvents.SelectMenuServices, {
          Template_id: themeContext.templateId
        });
      }
    }] :

    []),
    ...(dataAboutUs ?
    [
    {
      link: `${pathname}/${makeUrl(pathname, "sobre-nosotros")}`,
      icon: "icon-store",
      text: t("main_header.about"),
      onClick: () => {
        logEvent(MainSidebarMenuEvents.SelectMenuContactAboutUs, {
          Template_id: themeContext.templateId
        });
      }
    }] :

    []),
    {
      onClick: () => {
        handleShowStoreInfo();
        onClose && onClose();
        logEvent(MainSidebarMenuEvents.SelectMenuContactUs, {
          Template_id: themeContext.templateId
        });
      },
      icon: "icon-comments-outline",
      text: t("main_header.contact")
    }];

  }, [hasOffers, hasWholesale, hasServices]);

  const handleOnSignin = () => {
    handleShowLogin();
    onClose && onClose();
  };

  return (
    <UiModal
      title=''
      type={ModalType.LEFT}
      styles={{
        padding: "0",
        maxWidth: `420px`
      }}
      body={{
        styles: {
          padding: "0"
        }
      }}
      onClose={onClose}
      show={true}>

      <section className={styles.sideMenu2Styled}>
        <nav className={styles.sideMenu2Container}>
          <ul className={styles.sideMenu2Items}>
            <li className={styles.sideMenu2Item}>
              <ItemLink
                to={`${pathname}/${makeUrl(pathname, "")}`}
                onClick={() => {
                  logEvent(MainSidebarMenuEvents.SelectMenuHome, {
                    Template_id: themeContext.templateId
                  });
                }}>

                <>
                  <span className='icon-home-outline' />
                  {t("main_header.home")}
                </>
              </ItemLink>
            </li>
            {categories && categories.length &&
            <li className={styles.sideMenu2Item}>
                <button
                className={`${styles.sideMenu2Link} ${
                categoriesShowList && styles.sideMenu2LinkActive
                }`}
                onClick={handleClickCategoriesList}>

                  <span className='icon-view-grid-outline' />
                  {t("main_header.categories")}
                  <span className={`${styles.arrowDown} icon-arrow-2`} />
                </button>
                <ul
                className={`${styles.sideMenu2SubItems} ${
                categoriesShowList && styles.sideMenu2SubItemsActive
                }`}>

                  {categories.map((category, index) =>
                <li key={`sideMenu-category-${index}`}>
                      <span className={styles.sideMenu2ItemContent}>
                        <ItemLink
                      to={`${pathname}/${makeUrl(
                        pathname,
                        `categoria/${categoryNormalize(
                          category.category.id
                        )}`
                      )}`}
                      onClick={() =>
                      handleSelectCategory(category.category)}>


                          {category.category.name}
                        </ItemLink>
                        {category.subCategories &&
                    <button
                      className={`${styles.sideMenu2Link} ${
                      categorySelected === category.category.id &&
                      styles.sideMenu2LinkActive
                      }`}
                      onClick={() =>
                      handleShowSubcategories(category.category)}>


                            <span
                        className={`${styles.arrowDown} icon-arrow-2`} />

                          </button>}

                      </span>
                      {category.subCategories &&
                  categorySelected === category.category.id &&
                  <ul
                    className={`${styles.sideMenu2SubItems} ${
                    categoriesShowList &&
                    styles.sideMenu2SubItemsActive
                    }`}>

                            {category.subCategories.map(
                      (subcategory, subindex) =>
                      <li
                        className={styles.sideMenu2Item}
                        key={`sideMenu-subcategory-${index}-${subindex}`}>

                                  <ItemLink
                          to={`${pathname}/${makeUrl(
                            pathname,
                            `categoria/${categoryNormalize(
                              category.category.id
                            )}/${categoryNormalize(subcategory.id)}`
                          )}`}>

                                    {subcategory.name}
                                  </ItemLink>
                                </li>

                    )}
                          </ul>}

                    </li>
                )}
                </ul>
              </li>}

            {menuItems.map((item, index) =>
            <li className={styles.sideMenu2Item} key={`menu-item-${index}`}>
                {item.link &&
              <ItemLink to={item.link} onClick={item.onClick || undefined}>
                    <>
                      <span className={item.icon} />
                      {item.text}
                    </>
                  </ItemLink>}

                {!item.link &&
              <span
                className={styles.sideMenu2Link}
                onClick={item.onClick || undefined}>

                    <span className={item.icon} />
                    {item.text}
                  </span>}

              </li>
            )}
          </ul>
        </nav>
        {SHOW_LOGIN_BUTTON &&
        <div className={styles.sideMenu2Footer}>
            {isLoggedIn &&
          <>
                <div className={styles.sideMenu2FooterGrid}>
                  <a
                className={styles.sideMenu2FooterButton}
                href={`/features/dashboard/perfil?partnerId=${storeUserPathName}`}
                onClick={() =>
                logEvent(MainSidebarMenuEvents.SelectViewProfile, {
                  source: "menu"
                })}>


                    <span className='icon-account-circle-outline' />
                    {t("profile.profile_text")}
                  </a>
                  <a
                className={styles.sideMenu2FooterButton}
                href={`/features/dashboard/historial`}
                onClick={() =>
                logEvent(MainSidebarMenuEvents.SelectViewProfile, {
                  source: "menu"
                })}>


                    <span className='icon-shopping-outline' />
                    {t("profile.my_shopping")}
                  </a>
                </div>
                <UiButton
              className={`${styles.sideMenu2FooterButton} ${styles.danger}`}
              onClick={handleCloseSession}>

                  <span className='icon-logout-outline' />
                  {t("profile.logout")}
                </UiButton>
              </>}

            {!isLoggedIn &&
          <UiButton
            className={styles.sideMenu2FooterButton}
            onClick={handleOnSignin}>

                <span className='icon-account-circle-outline' />
                {t("main_header.sign_in")}
              </UiButton>}

          </div>}

      </section>
    </UiModal>);

};